export default {
    name: "Bitcoin Cash",
    coin: "BCH",
    scheme: "SOLO",
    account: 'qqva9g3j8de4evpt95p4y4h5c3lwuw42gc3nwrq9ms',
    explorer_url: 'https://explorer.melroy.org/ru/mining/pool/molepool',
    coingecko: 'https://www.coingecko.com/en/coins/bitcoin-cash',
    explorer: {
        address: "https://explorer.melroy.org/address/",
        height: "https://explorer.melroy.org/block/",
        hash: "https://explorer.melroy.org/block/",
        tx: "https://explorer.melroy.org/tx/",
    },
    ports: [
        {
            info: "LOW",
            host: "molepool.com",
            port: 5566,
            diff: 65536,
        },
        {
            info: "MID",
            host: "molepool.com",
            port: 5567,
            diff: 1048576,
        },
        {
            info: "HIGH",
            host: "molepool.com",
            port: 5568,
            diff: 10485760,
        }
    ]
};
